import { render, staticRenderFns } from "./advantages.vue?vue&type=template&id=6ca3ac9b&scoped=true"
import script from "./advantages.vue?vue&type=script&lang=js"
export * from "./advantages.vue?vue&type=script&lang=js"
import style0 from "./advantages.vue?vue&type=style&index=0&id=6ca3ac9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca3ac9b",
  null
  
)

export default component.exports